// Feature flags — single source of truth for hiding/showing product surfaces.
//
// Each flag controls a whole product's visitor-facing footprint (homepage
// card, navigation link, purchase route). Components import the specific
// constant they need and conditionally render.
//
// To re-enable a hidden product, flip its flag to `true` here. No other
// code changes required.

// ---------------------------------------------------------------------------
// Employee Handbook Service ($649 Done-For-You)
// ---------------------------------------------------------------------------
// HIDDEN pre-launch: vendor pricing not yet finalized. All Handbook code,
// pages, components, backend product record, and Stripe wiring remain
// intact; visitors just can't reach or see any of it.
//
// To re-enable: change to `true`, save, and (in production) redeploy. That
// restores the homepage card, the mobile-nav "Handbook Builder" link, the
// /handbook-builder route, and the /handbook-builder-purchase route.
// ---------------------------------------------------------------------------
export const HANDBOOK_ENABLED = false;
